import React, { Component, PropTypes } from 'react';
import { Link, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { verifyPhoneByLink } from 'common/ducks/user';
import { LoadingIndicator } from 'common/components/preloader';


class VerifyPhone extends Component {
  componentDidMount() {
    const { verifyPhoneByLink, base64String, hexString, mobileValidated } = this.props;
    if (!mobileValidated) {
      verifyPhoneByLink(base64String, hexString);
    }
  }

  render() {
    const { mobileValidated } = this.props;

    return (
      <div className="l-content info-screen" id="content">
        {mobileValidated === undefined?
        <LoadingIndicator/>:
        <div className="row">
          <div className="columns medium-8 small-16">

            <h2>{mobileValidated? 'Phone Verified':'Phone Verification Failed'}</h2>

            {mobileValidated?
            <p>
              Thanks for verifying your phone. We take the protection of your identity
              and personal information seriously. To learn more about how we protect your
              privacy, visit our <Link to="/help/">help center</Link>.
            </p>:
            <p>
              We take the protection of your identity and personal information seriously.
              To learn more about how we protect your privacy, visit
              our <Link to="/help/">help center</Link>. Please contact contact customer service
              to fix this.
            </p>}

            {mobileValidated?
            <Link to="/account/info/" className="btn btn-primary">
              Go to my account
            </Link>:
            <Link className="btn btn-tertiary" to="/help/contact/">Get in touch</Link>}

          </div>

          <div className="columns medium-8 small-16 icon hide-for-small-only">
            <i className={"fa fa-" + (mobileValidated? "check-circle":"frown-o")}></i>
          </div>
        </div>}

      </div>
    );
  }
}

VerifyPhone.propTypes = {
  base64String: PropTypes.string,
  hexString: PropTypes.string,
  mobileValidated: PropTypes.bool,
};

function mapStateToProps(state, { params, location: { query } }) {
  return {
    base64String: params.verifyString,
    hexString: params.hexString,
    mobileValidated: state.user.mobileValidated
  };
}

export default withRouter(connect(mapStateToProps, { verifyPhoneByLink })(VerifyPhone));



// WEBPACK FOOTER //
// ./common/components/verify_phone.jsx